export const isEmail = (text: string): boolean => {
    const mailRegexPattern =  /^(?!.*\.\.)(?!.*@-)(?!.*-@)(?!.*@.*--)[a-zA-Z0-9._%+-]+@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{2,}$/;
    return mailRegexPattern.test(text);
};